import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
  selector: 'app-queued-jobs-icon',
  standalone: true,
  imports: [NgClass],
  templateUrl: './queued-jobs-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'tw-flex' }
})
export class QueuedJobsIconComponent {
  public size = input<number>(18)
  public fillClass = input<string>('tw-fill-gray-500')
}
